import React from 'react';

const DiscoverPage = () => {
  return (
    <div className="page-container">
      <h1>Discover Talent</h1>
      <p>This is where the main application for discovering talented individuals will be. Browse profiles, projects, and portfolios in our cosmic showcase.</p>
    </div>
  );
};

export default DiscoverPage;